function getAssignments(sub) {
  let assignments= [];
  if (localStorage.getItem("module")) {
    let tempAssgn = JSON.parse(localStorage.modules);
    tempAssgn.forEach(modules => {
      assignments.push({umdId: sub, moduleCode: module.value, moduleAssigned: module.label, roleCode: "READ", roleAssigned: "Read"})
    });
  }
  return assignments;
}
export function setNewUser(user) {
  const { given_name, family_name, email, sub, account_type } = user;
  let newUser = {
    isPublic: account_type === "Employee" ? false : true,
    isStaff: account_type === "Employee" ? true : false,
    isSysAdmin: false,
    isPortalUser: false,
    isActive: true,
    firstName: given_name,
    lastName: family_name,
    email,
    umdId: sub,
    assignments: getAssignments()
  };
  return newUser;
}

export function setUserProfile(user) {
  const { firstName, lastName, email, umdId, isStaff, isSysAdmin, isPortalUser, isActive, assignments, systems, permissions } = user;
  let appUser = {
    isPublic: !isActive,
    isStaff,
    isSysAdmin,
    isPortalUser,
    isActive,
    firstName,
    lastName,
    email,
    umdId,
    assignments,
    systems,
    permissions
  };
  return appUser;
}
